import { Selector } from '@ngxs/store';
import { OnderwijsLocatiesStateModel } from '@store/models/onderwijs-locaties.model';
import { OnderwijsLocatiesState } from '@store/states/onderwijs-locaties.state';

export class OnderwijsLocatiesSelectors {
  @Selector([OnderwijsLocatiesState])
  static onderwijsLocaties(state: OnderwijsLocatiesStateModel) {
    return state.onderwijsLocaties;
  }

  @Selector([OnderwijsLocatiesState])
  static onderwijsLocatiesAsCheckboxes(state: OnderwijsLocatiesStateModel) {
    return state.onderwijsLocaties.map((onderwijsLocatie) => {
      return {
        label: onderwijsLocatie.naam,
        value: onderwijsLocatie.onderwijsLocatieId,
      };
    });
  }

  @Selector([OnderwijsLocatiesState])
  static onderwijsLocatiesLoading(state: OnderwijsLocatiesStateModel) {
    return state.loading;
  }

  @Selector([OnderwijsLocatiesState])
  static onderwijsLocatiesError(state: OnderwijsLocatiesStateModel) {
    return state.error;
  }

  @Selector([OnderwijsLocatiesState])
  static onderwijsLocatiesLoaded(state: OnderwijsLocatiesStateModel) {
    return state.loaded
  }

  @Selector([OnderwijsLocatiesState])
  static selectedOnderwijsLocatie(state: OnderwijsLocatiesStateModel) {
    // find onderwijsLocatie on selectedOnderwijsLocatieId
    return state.onderwijsLocaties.filter(ol => ol.onderwijsLocatieId === state.selectedOnderwijsLocatieId)[0];
  }

  @Selector([OnderwijsLocatiesState])
  static selectedOnderwijsLocatieId(state: OnderwijsLocatiesStateModel) {
    // find onderwijsLocatie on selectedOnderwijsLocatieId
    return state.selectedOnderwijsLocatieId;
  }

  @Selector([OnderwijsLocatiesState])
  static selectedSchool(state: OnderwijsLocatiesStateModel) {
    return state.selectedSchool;
  }

}
